import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { createContext, useContext } from 'react';
export const GameSuiteContext = createContext(null);
export const GameSuiteProvider = GameSuiteContext.Provider;
export function withGame(Component) {
    const ObservedComp = observer(Component);
    return function WithGame(props) {
        const gameSuite = useGameSuite();
        return _jsx(ObservedComp, { ...props, gameSuite: gameSuite });
    };
}
export function useGameSuite() {
    const suite = useContext(GameSuiteContext);
    if (!suite) {
        throw new Error('GameSessionProvider not found');
    }
    return suite;
}
export function typedHooks() {
    function useGameSuiteTyped() {
        return useGameSuite();
    }
    function withGameTyped(Comp) {
        return withGame(Comp);
    }
    return {
        useGameSuite: useGameSuiteTyped,
        withGame: withGameTyped,
    };
}
//# sourceMappingURL=GameSuiteContext.js.map